export const ORDER_CREATE_LOADING = 'ORDER_CREATE_LOADING'
export const ORDER_CREATE_COMPLETE = 'ORDER_CREATE_COMPLETE'
export const ORDER_CREATE_ERROR = 'ORDER_CREATE_ERROR'

export const GET_ORDERS_LOADING = 'GET_ORDERS_LOADING'
export const GET_ORDERS_COMPLETE = 'GET_ORDERS_COMPLETE'
export const GET_ORDERS_ERROR = 'GET_ORDERS_ERROR'

export const GET_ORDER_DETAIL_LOADING = 'GET_ORDER_DETAIL_LOADING'
export const GET_ORDER_DETAIL_COMPLETE = 'GET_ORDER_DETAIL_COMPLETE'
export const GET_ORDER_DETAIL_ERROR = 'GET_ORDER_DETAIL_ERROR'

export const CHANGE_STATUS_ORDER_LOADING = 'CHANGE_STATUS_ORDER_LOADING'
export const CHANGE_STATUS_ORDER_COMPLETE = 'CHANGE_STATUS_ORDER_COMPLETE'
export const CHANGE_STATUS_ORDER_ERROR = 'CHANGE_STATUS_ORDER_ERROR'

export const UPDATE_ORDERS = 'UPDATE_ORDERS'

export const ORDER_SERVICES_CREATE_LOADING = 'ORDER_SERVICES_CREATE_LOADING'
export const ORDER_SERVICES_CREATE_COMPLETE = 'ORDER_SERVICES_CREATE_COMPLETE'
export const ORDER_SERVICES_CREATE_ERROR = 'ORDER_SERVICES_CREATE_ERROR'

export const SET_STRIPE_CLIENT_SECRET_LOADING = 'SET_STRIPE_CLIENT_SECRET_LOADING'
export const CLEAN_STRIPE_CLIENT_SECRET = 'CLEAN_STRIPE_CLIENT_SECRET'

export const SET_STRIPE_CLIENT_SECRET_COMPLETE = 'SET_STRIPE_CLIENT_SECRET_COMPLETE'
export const SET_STRIPE_CLIENT_SECRET_ERROR = 'SET_STRIPE_CLIENT_SECRET_ERROR'


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/order/mutation-types.js
// module id = null
// module chunks = 